"use client";

// =============================================================================
// BypassQueryCleanup — strippt `?bypass=TOKEN` per history.replaceState
// -----------------------------------------------------------------------------
// Background: src/proxy.ts setzt das Bypass-Cookie OHNE 307-Redirect (Perf-
// Optimierung gegen Lighthouse "redirects"-Opportunity, spart ~781ms LCP).
// Konsequenz: Der `?bypass=TOKEN`-Query bleibt nach dem ersten Render in der
// Adressleiste. Funktional egal (Cookie ist gesetzt), aber:
//   - sieht in der URL hässlich aus
//   - landet in Shares/Lesezeichen → Token-Leakage
//   - History-Back führt zu doppelter Render-Iteration mit Query
//
// Dieser Component räumt den Query client-seitig per history.replaceState
// auf — kein Re-Render, kein Re-Fetch, nur Adressleiste sauber. Mountet in
// app/layout.tsx (sitewide).
// =============================================================================

import { useEffect } from "react";

export function BypassQueryCleanup() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const url = new URL(window.location.href);
    if (url.searchParams.has("bypass")) {
      url.searchParams.delete("bypass");
      window.history.replaceState({}, "", url.toString());
    }
  }, []);

  return null;
}
